module.exports = __webpack_public_path__ + "static/img/QR.c323e898.png";